export default {
    csManagement: {
        page: {
            title: 'CS Management',
            description: 'Manage tenant quotas, document limits and token consumption',
        },
        quota: {
            searchPlaceholder: 'Search tenant ID',
            typePlaceholder: 'Quota type',
            search: 'Search',
            create: 'Add Quota',
            tenantId: 'Tenant ID',
            quotaType: 'Quota Type',
            typeDocument: 'Document',
            typeToken: 'Token',
            quotaLimit: 'Limit',
            quotaUsed: 'Used',
            contractPeriod: 'Contract Period',
            contractStart: 'Start Date',
            contractEnd: 'End Date',
            status: 'Status',
            statusActive: 'Active',
            statusExpired: 'Expired',
            remark: 'Remark',
            action: 'Action',
            edit: 'Edit',
            delete: 'Delete',
            createTitle: 'Add Quota',
            editTitle: 'Edit Quota',
            cancel: 'Cancel',
            confirm: 'Confirm',
        },
    },
}
